<template>
  <div class="profile-header">
    <router-link
      v-if="model.username"
      :to="{
        name: 'model.username',
        params: { username: '@' + model.username },
      }"
      class="profile-link"
    >
      <div
        class="pic"
        :style="{
          backgroundImage: `url('${model.public_profile_image_path}')`,
        }"
      ></div>
      <div class="names">
        <div v-if="model.name" class="name">
          {{ model.name }}
          <img
            v-if="model.verified"
            class="badge-verified"
            src="/img/verified.png"
            alt="verified"
            title="verified"
          />
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import("../../../../public/js/lib/FontAwesomeKit"); // <--- importing FontAwesome icons

export default {
  props: {
    model: {},
  },
};
</script>

<style scoped lang="scss">
@import "../../../styles/variables";

.container {
  display: flex;
  position: relative;
  margin-inline: 0;

  .btn-chat {
    margin-right: 36px;
  }
}

.profile-header {
  min-height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25em;

  .profile-link {
    display: flex;
    justify-content: start;
    align-items: center;

    .pic {
      width: 50px;
      height: 50px;
      margin-inline: 10px;
      margin-block: 10px 5px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      background-color: #ffffff;
      border-radius: 50%;
      border: 3px solid #ffffff;
    }

    .names {
      max-width: calc(100% - 60px);

      .name {
        // display: flex;
        display: block;
        align-items: center;
        font-size: 1.2em;
        font-weight: bold;
        text-wrap: balance;
        margin-right: 5px;

        img {
          &.badge-verified {
            width: 15px;
            margin: 3px 0 1px 2px;
            vertical-align: middle;
          }
        }
      }

      .username {
        color: #444;
        font-size: 0.8em;
      }

      &:hover {
        color: #666666;
      }
    }
  }
}
</style>
